import { gql } from '@apollo/client';

export const ALL_INVENTORY_ITEMS_QUERY = gql`
  query AllInventoryItems($domainId: Int!) {
    allInventoryItems(
      condition: { domainId: $domainId }
      orderBy: [INVENTORY_TYPE_ASC, NAME_ASC]
    ) {
      nodes {
        id
        name
        description
        inventoryType
        costCents
        quantityOnHand
        widthInches
        costLastUpdatedAt
        createdAt
        archivedAt
        unitByUnitId {
          id
          name
          abbreviation
        }
      }
    }
  }
`;

export const ALL_UNITS_QUERY = gql`
  query AllUnits {
    allUnits(orderBy: NAME_ASC) {
      nodes {
        id
        name
        abbreviation
      }
    }
  }
`;

export const CREATE_INVENTORY_ITEM_MUTATION = gql`
  mutation CreateInventoryItem(
    $domainId: Int!
    $name: String!
    $inventoryType: InventoryItemTypeEnum!
    $unitId: Int!
    $costCents: Int!
    $description: String
    $widthInches: BigFloat
    $quantityOnHand: BigFloat
  ) {
    createInventoryItem(input: {
      inventoryItem: {
        domainId: $domainId
        name: $name
        inventoryType: $inventoryType
        unitId: $unitId
        costCents: $costCents
        description: $description
        widthInches: $widthInches
        quantityOnHand: $quantityOnHand
      }
    }) {
      inventoryItem { id }
    }
  }
`;

export const UPDATE_INVENTORY_ITEM_MUTATION = gql`
  mutation UpdateInventoryItem($id: Int!, $patch: InventoryItemPatch!) {
    updateInventoryItemById(input: { id: $id, inventoryItemPatch: $patch }) {
      inventoryItem { id }
    }
  }
`;
